import { render, staticRenderFns } from "./ApproveItem.vue?vue&type=template&id=7d0bc266&scoped=true&"
import script from "./ApproveItem.vue?vue&type=script&lang=js&"
export * from "./ApproveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0bc266",
  null
  
)

export default component.exports